import { useTranslation } from "react-i18next";
import i18next from "src/i18n/config";

import { PageContainer } from "@dashboard/shared/components/PageContainer";
import PageHeader from "@dashboard/shared/components/PageHeader";
import { withMetaDescription } from "@navigation/utils/withMetaDescription";
import { ExpiredWrapper } from "@shared/ExpiredWrapper";

import { SidePanel } from "../shared/components/SidePanel/SidePanel";

import { DeviceTable } from "./components/Table/DeviceTable";

const DevicesPage = () => {
    const { t } = useTranslation(["pages"]);

    return (
        <PageContainer fitViewport>
            <PageHeader title={t("pages:devicePage.title")} description={t("pages:devicePage.description")} />
            <ExpiredWrapper>
                <DeviceTable />
            </ExpiredWrapper>
            <SidePanel />
        </PageContainer>
    );
};

export default withMetaDescription(DevicesPage, {
    title: i18next.t("pages:devicePage.metaTitle"),
    description: i18next.t("pages:devicePage.metaDescription"),
});
